var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMilitaryDiscountSolid = function SvgMilitaryDiscountSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25a6.75 6.75 0 0 0-4.75 11.546V21a.75.75 0 0 0 .932.728L12 20.773l3.818.955A.75.75 0 0 0 16.75 21v-7.204A6.75 6.75 0 0 0 12 2.25ZM8.75 20.04v-5.123c.965.531 2.073.833 3.25.833a6.724 6.724 0 0 0 3.25-.833v5.122l-3.068-.767a.749.749 0 0 0-.364 0l-3.068.767ZM9.25 7a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H10A.75.75 0 0 1 9.25 7Zm4.22-.53a.75.75 0 1 1 1.061 1.06l-4 4a.75.75 0 1 1-1.06-1.06l4-4ZM13.24 11a.75.75 0 0 1 .75-.75H14a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgMilitaryDiscountSolid;